module.exports = __webpack_public_path__ + "static/media/hafil.dc902e19.jpg";